import { createReducer, on } from '@ngrx/store';
import { ManageCartsActions } from '../actions';
import { ActiveCartState } from '../state/cart-details.state';
import { ErrorModel } from '@spartacus/core';

export const initialState: ActiveCartState = {
  loading: null,
  success: null,
  error: null,
};

const _activeCartReducer = createReducer(
  initialState,
  on(ManageCartsActions.setActiveCartCall, (state: ActiveCartState): ActiveCartState => ({
    ...state,
    loading: true,
    success: null,
    error: null
  })),
  on(ManageCartsActions.setActiveCartSuccess, (state: ActiveCartState, { success }): ActiveCartState => {
    console.log('setActiveCartSuccess:', { state });
    return {
      ...state,
      success,
      loading: null,
      error: null
    };
  }),
  on(ManageCartsActions.setActiveCartFailure, (state: ActiveCartState, { error }): ActiveCartState => {
    console.log('setActiveCartFailure:', { error });
    return {
      ...state,
      loading: null,
      success: null,
      error: { message: error } as ErrorModel,
    };
  }),
);

export function activeCartReducer(state, action) {
  return _activeCartReducer(state, action);
}